<kendo-dialog [width]="'94%'" [minWidth]="300" [maxWidth]="520" [maxHeight]="'90vh'">
  <ng-container *ngIf="!carregando; else loadingTemplate">
    <kendo-dialog-titlebar>
      <span class="dialog-title">
        <i class="fas fa-link"></i> Vincular {{nomeAlvoComInicialMaiuscula()}}
      </span>
    </kendo-dialog-titlebar>

    <!-- Estado inicial -->
    <div class="form-container" *ngIf="!leituraCartaoAberta">
      <div class="scanner-cta">
        <div class="cta-icon-wrap">
          <i class="fas fa-qrcode"></i>
        </div>
        <h3>Leitura de {{nomeAlvoComInicialMaiuscula()}}</h3>
        <p>Escaneie o QR Code da {{nomeAlvo()}} para vincular ao seu pedido.</p>
        <button kendoButton themeColor="primary" class="btn-scan" (click)="lerQRCode()" type="button">
          <i class="fas fa-camera"></i> Abrir Câmera
        </button>
      </div>

      <div *ngIf="erro" class="erro-container">
        <i class="fas fa-exclamation-triangle"></i>
        <span>{{ erro }}</span>
      </div>
    </div>

    <!-- Scanner ativo -->
    <div class="scanner-view" *ngIf="leituraCartaoAberta">
      <div class="scanner-wrapper">
        <zxing-scanner
          (scanSuccess)="onCodeResult($event)"
          (permissionResponse)="$event || onCameraError($event)">
        </zxing-scanner>
        <div class="scanner-overlay">
          <div class="scan-target">
            <span class="corner tl"></span>
            <span class="corner tr"></span>
            <span class="corner bl"></span>
            <span class="corner br"></span>
            <div class="scan-line"></div>
          </div>
        </div>
      </div>

      <div class="scanner-hint">
        <i class="fas fa-info-circle"></i>
        Posicione o QR Code da {{nomeAlvo()}} dentro da área marcada
      </div>

      <div class="scanner-actions">
        <button kendoButton look="outline" class="btn-cancel-scan" (click)="fecharLeituraCartao()">
          <i class="fas fa-times"></i> Cancelar Leitura
        </button>
      </div>
    </div>

    <kendo-dialog-actions>
      <button kendoButton (click)="fechar()">Fechar</button>
    </kendo-dialog-actions>
  </ng-container>

  <ng-template #loadingTemplate>
    <div class="loading">
      <div class="loading-spinner"></div>
      <p>Processando pedido...</p>
    </div>
  </ng-template>
</kendo-dialog>
